import type {ThesaurusNode} from '../types';

export const modifyThesaurusNodeByIds = (
  nodes: ThesaurusNode[],
  ids: string[],
  modification: Partial<ThesaurusNode>,
) => {
  nodes.forEach((node, i) => {
    if (matchIds(node, ids)) {
      nodes[i] = {
        ...node,
        ...modification,
      };
    }
    if (node.children) {
      modifyThesaurusNodeByIds(node.children, ids, modification);
    }
  });

  return nodes;
};

/**
 * Returns true if id match, or if start of id matches a prefix
 * with '*' wildcard at the end.
 */
const matchIds = (node: ThesaurusNode, ids: string[]): boolean => {
  if (ids.includes(node.id)) {
    return true;
  }

  return ids.some(id => {
    if (id.endsWith('*')) {
      const prefix = id.slice(0, -1);
      if (node.id.startsWith(prefix)) {
        return true;
      }
    }
  });
};
